import axios from "axios";

let token = "";
if (token) token = JSON.parse(token);

let apiUrl = process.env.REACT_APP_API_URL;
if (!apiUrl || apiUrl.includes("localhost:9024")) {
	apiUrl = "http://localhost:9023";
}

const axiosInstance = axios.create({
	baseURL: `${apiUrl}/api`,
	headers: {
		authorization: token,
	},
});

export default axiosInstance;
